import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TextboxField } from '../../../models/Field';

@Component({
  selector: 'checkbox-1',
  template: `<div
    [formGroup]="form"
    class="form-group"
    [style.width]="field.size ? field.size + 'em' : ''"
    style="max-width: 100%;"
  >
    <label [attr.for]="field.key">{{ field.label }}</label>
    <input
      [formControlName]="field.key"
      type="checkbox"
      [id]="field.key"
      [name]="field.key"
      [checked]="field.value"
      style="display: block;"
    />
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class Chekbox1Component {
  @Input() form: FormGroup;
  @Input() field: TextboxField;

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/checkbox/checkbox-1.component.ts